import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import Layout from './components/Layout.vue'

import './assets/font/font.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// import axios from 'axios'

// 屏幕缩放
// import { detectZoom } from '@/utils/detectZoom.js'

// const m = detectZoom()
// const screenWidth = document.body.clientWidth
// // 处理笔记本系统默认系统比例为125%或150%带来的布局影响
// if(screenWidth > 768 && screenWidth <= 1200) {
//   document.body.style.zoom = 100 / Number(m)
// }

Vue.use(ElementUI)
Vue.use(VueQuillEditor)
// Vue.use(axios);
import 'vant/lib/index.css'
import { Picker } from 'vant'
import { Popup } from 'vant'
import { Dialog } from 'vant'

Vue.use(Picker)
Vue.use(Popup)
Vue.use(Dialog)

new Vue({
    el: '#app',
    router,
    render: (h) => h(Layout)
})
